import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetInternshipLocationUseCaseInterface } from 'domain/usecases';

export class RemoteInternshipLocation
  implements GetInternshipLocationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetInternshipLocationUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetInternshipLocationUseCaseInterface.Params,
  ): Promise<GetInternshipLocationUseCaseInterface.Result> {
    const requestUrl = generateUrl(
      this.url,
      params as Record<string, string | number | string[]>,
    );

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
